export default "__VITE_PUBLIC_ASSET__b1f37a6b__"